export { default } from "./RegistroMovimientosIngredientes";
